import gql from 'graphql-tag';

// QUERIES

const ongoingPeriodsInAssociationQuery = gql`
  query ($associationId: ObjectId!) {
    periods: ongoingPeriodsInAssociation(associationId: $associationId) {
      fromPeriod
      toPeriod
      currentPeriod
    }
  }
`;

const statOrdersByAssociationQuery = gql`
  query ($associationId: ObjectId!, $bookletId: ObjectId, $fromDate: DateTime, $toDate: DateTime) {
    orders: statOrdersByAssociation(associationId: $associationId, bookletId: $bookletId, fromDate: $fromDate, toDate: $toDate) {
      #periods {
        #period
        #amount
        #number
      #}
      totalNumber
      totalUsedOrders
      
      # Nya fält för att separera webshop vs genererade orders
      webshopEarnings
      webshopOrders {
        _id
        code
        bookletId
        status
        teamId
        paidAmount
        paidDate
        completedDate
        userFirstname
        userLastname
        associationId
        associationName
        teamId
        teamName
        teamMemberId
        teamMemberFirstname
        teamMemberLastname
        supportAssociationId
      }
      generatedCompletedOrders {
        _id
        code
        bookletId
        status
        teamId
        completedDate
        userFirstname
        userLastname
      }
      #totalAmount
    }
  }
`;

const statAssociationTopTeamsQuery = gql`
  query ($associationId: ObjectId!, $fromDate: DateTime, $toDate: DateTime) {
    teams: statAssociationTopTeams(associationId: $associationId, fromDate: $fromDate, toDate: $toDate) {
      teams {
        team {
          _id
          name
        }
        total
      }
    }
  }
`;

const statAssociationTopTeamMembersQuery = gql`
  query ($associationId: ObjectId!, $fromDate: DateTime, $toDate: DateTime) {
    teamMembers: statAssociationTopTeamMembers(associationId: $associationId, fromDate: $fromDate, toDate: $toDate) {
      teamMembers {
        teamMember {
          _id
          firstname
          lastname
        }
        total
      }
    }
  }
`;

const getAssociationsQuery = gql`
  {
    associations: associations {
      _id
      zoneId
      name
      slug
      shopShareDomain
      visibleOnStartpageOfDomains
      supportableAssociations
      salesStartDate
      salesEndDate
      shopShareImageURL
      resellerFormAssociations
      resellerFormTeams
    }
  }
`;

const getVisibleAssociationsWithTeamsQuery = gql`
  query GetVisibleAssociationsWithTeams($domain: String!) {
    visibleAssociationsWithTeams(domain: $domain) {
      _id
      zoneId
      name
      slug
      shopShareDomain
      visibleOnStartpageOfDomains
      salesStartDate
      salesEndDate
      teams {
        _id
        associationId
        name
        slug
        salesStartDate
        salesEndDate
        teamMembers {
          _id
          firstname
          lastname
          slug
        }
      }
    }
  }
`;

/*const getAssociationsInCityQuery = gql`
  query ($cityId: ObjectId!) {
    associations: associationsInCity(cityId: $cityId) {
      _id
      cityId
      name
      phone
      billingAddress {
        streetAddress
        zipCode
        city
        state
      }
      note
      agreements {
        _id
        activeFrom
        activeTo
      }
      adminEmails
      adminInvitations {
        sentToEmail
        userIdActivated
      }
    }
  }
`;
*/

const getAssociationsInZoneQuery = gql`
  query ($zoneId: ObjectId!) {
    associations: associationsInZone(zoneId: $zoneId) {
      _id
      zoneId
      name
      slug
      phone
      billingAddress {
        streetAddress
        zipCode
        city
        state
      }
      note
      agreements {
        _id
        activeFrom
        activeTo
      }
      adminEmails
      adminInvitations {
        sentToEmail
        userIdActivated
      }
      shopShareDomain
      visibleOnStartpageOfDomains
      shopShareImageURL
      vatPercentage
      supportableAssociations
      salesStartDate
      salesEndDate
      type
      bankInformation {
        clearingNumber
        accountNumber
        accountOwner
      }
      resourceBank {
        username
        password
      }
      demoBooklet {
        email
        password
      }
    resellerFormAssociations
    resellerFormTeams
    subshopVisibilityInDashboard
    }
  }
`;

const getAssociationsNameInZoneQuery = gql`
  query ($zoneId: ObjectId!) {
    associations: associationsInZone(zoneId: $zoneId) {
      _id
      name
    }
  }
`;


const getAssociationQuery = gql`
  query ($associationId: ObjectId!) {
    association: association(associationId: $associationId) {
      _id
      zoneId
      name
      phone
      logoURL
      slug
      shopShareDomain
      billingAddress {
        streetAddress
        zipCode
        city
        state
      }
      note
      agreements {
        _id
        activeFrom
        activeTo
      }
      vatPercentage
      bankInformation {
        clearingNumber
        accountNumber
        accountOwner
      }
      resourceBank {
        username
        password
      }
      demoBooklet {
        email
        password
      }
      resellerFormAssociations
      resellerFormTeams
      subshopVisibilityInDashboard
    }
  }
`;

const getAssociationBySlug = gql`
  query ($slug: String!) {
    association: associationBySlug(slug: $slug) {
      _id
      name
      zoneId
      vatPercentage
      supportableAssociations
      salesStartDate
      salesEndDate
      shopShareDomain
    }
  }
`

const getAssociationPublicQuery = gql`
  query ($associationId: ObjectId!) {
    association: associationPublic(associationId: $associationId) {
      _id
      name
      logoURL
      shopShareDomain
      slug
      subshopVisibilityInDashboard
    }
  }
`;

// MUTATIONS

const addAssociationMutation = gql`
  mutation(
    $zoneId: ObjectId!,
    $name: String!,
    $phone: String,
    $note: String,
    $logoURL: String,
    $bStreetAddress: String
    $bZipCode: String
    $bCity: String
    $bState: String
    $shopShareDomain: String!
    $visibleOnStartpageOfDomains: [String!]
    $shopShareImageURL: String
    $vatPercentage: Int
    $salesStartDate: DateTime
    $salesEndDate: DateTime
    $supportableAssociations: [ObjectId!]
    $type: String
    $bankInformation: BankInformationInput
    $resourceBank: ResourceBankInput
    $demoBooklet: DemoBookletInput
    $resellerFormAssociations: String
    $resellerFormTeams: String
    $subshopVisibilityInDashboard: SubshopVisibilityMode
    ) {
    createAssociation(
      zoneId: $zoneId,
      name: $name,
      phone: $phone,
      logoURL: $logoURL,
      note: $note,
      billingAddress: {
        streetAddress: $bStreetAddress
        zipCode: $bZipCode
        city: $bCity
        state: $bState
      }
      shopShareDomain: $shopShareDomain
      visibleOnStartpageOfDomains: $visibleOnStartpageOfDomains
      shopShareImageURL: $shopShareImageURL
      vatPercentage: $vatPercentage
      salesStartDate: $salesStartDate
      salesEndDate: $salesEndDate
      supportableAssociations: $supportableAssociations
      type: $type
      bankInformation: $bankInformation
      resourceBank: $resourceBank
      demoBooklet: $demoBooklet
      resellerFormAssociations: $resellerFormAssociations
      resellerFormTeams: $resellerFormTeams
      subshopVisibilityInDashboard: $subshopVisibilityInDashboard
      ) {
        _id
      }
    }
`;

const updateAssociationMutation = gql`
  mutation(
    $_id: ObjectId!
    $name: String!
    $phone: String
    $note: String
    $logoURL: String
    $bStreetAddress: String
    $bZipCode: String
    $bCity: String
    $bState: String
    $adminEmails: [String!]
    $shopShareDomain: String!
    $visibleOnStartpageOfDomains: [String!]
    $shopShareImageURL: String
    $vatPercentage: Int
    $slug: String
    $salesStartDate: DateTime
    $salesEndDate: DateTime
    $supportableAssociations: [ObjectId!]
    $type: String
    $bankInformation: BankInformationInput
    $resourceBank: ResourceBankInput
    $demoBooklet: DemoBookletInput
    $resellerFormAssociations: String
    $resellerFormTeams: String
    $subshopVisibilityInDashboard: SubshopVisibilityMode
    $paidOutByBooklet: [PaidOutAmountInput!]
    ) {
    updateAssociation(
      _id: $_id,
      name: $name,
      phone: $phone,
      note: $note,
      logoURL: $logoURL,
      adminEmails: $adminEmails,
      billingAddress: {
        streetAddress: $bStreetAddress
        zipCode: $bZipCode
        city: $bCity
        state: $bState
      },
      shopShareDomain: $shopShareDomain
      visibleOnStartpageOfDomains: $visibleOnStartpageOfDomains
      shopShareImageURL: $shopShareImageURL
      vatPercentage: $vatPercentage
      slug: $slug
      salesStartDate: $salesStartDate
      salesEndDate: $salesEndDate
      supportableAssociations: $supportableAssociations
      type: $type
      bankInformation: $bankInformation
      resourceBank: $resourceBank
      demoBooklet: $demoBooklet
      resellerFormAssociations: $resellerFormAssociations
      resellerFormTeams: $resellerFormTeams
      subshopVisibilityInDashboard: $subshopVisibilityInDashboard
      paidOutByBooklet: $paidOutByBooklet
      ) {
        _id
    }
  }
`;


const addAgreementToAssociationMutation = gql`
  mutation(
    $associationId: ObjectId!
    $activeFrom: Int!
    $activeTo: Int!
    ) {
      addAssociationAgreement(
        associationId: $associationId,
        activeFrom: $activeFrom,
        activeTo: $activeTo,
        ) {
        _id
      }
    }
`;

const updateAgreementInAssociationMutation = gql`
  mutation(
    $associationId: ObjectId!
    $_id: ObjectId!
    $activeFrom: Int!
    $activeTo: Int!
    ) {
      updateAssociationAgreement(
        associationId: $associationId,
        agreementId: $_id,
        activeFrom: $activeFrom,
        activeTo: $activeTo,
        ) {
          _id
      }
    }
`;

export {
  ongoingPeriodsInAssociationQuery,
  statOrdersByAssociationQuery,
  statAssociationTopTeamsQuery,
  statAssociationTopTeamMembersQuery,
  getAssociationQuery,
  getAssociationBySlug,
  getAssociationPublicQuery,
  getAssociationsQuery,
  getVisibleAssociationsWithTeamsQuery,
  //getAssociationsInCityQuery,
  getAssociationsInZoneQuery,
  getAssociationsNameInZoneQuery,
  addAssociationMutation,
  updateAssociationMutation,
  addAgreementToAssociationMutation,
  updateAgreementInAssociationMutation,
};
